module.exports = __webpack_public_path__ + "static/img/logo.693d312.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/logo.svg
// module id = cY7L
// module chunks = 4